module.exports = __webpack_public_path__ + "static/img/jukan-tateisi-bJhT_8nbUA0-unsplash_thumb.d2069bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/jukan-tateisi-bJhT_8nbUA0-unsplash_thumb.png
// module id = zIYw
// module chunks = 4